(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/cookie-consent/assets/javascripts/cookie-consent.js') >= 0) return;  svs.modules.push('/components/core/cookie-consent/assets/javascripts/cookie-consent.js'); 
'use strict';

svs.core = svs.core || {};
svs.core.cookie_consent = svs.core.cookie_consent || {};
svs.core.cookie_consent.data = svs.core.cookie_consent.data || {};
svs.core.cookie_consent.DataHandler = function () {
  const cookieName = 'cookie_consent';
  const cookieVersion = svs.core.cookie_consent.data.cookieVersion || 0;
  const allowedValues = ['ad', 'personalized', 'analytics', 'provision'];
  return {
    setConsent: config => new Promise((resolve, reject) => {
      const cookieValue = {};
      for (const key of Object.keys(config)) {
        if (allowedValues.indexOf(key) === -1) {
          reject(Error("Unknown property '".concat(key, "'")));
          return;
        } else if (typeof config[key] !== 'boolean') {
          reject(Error("The property '".concat(key, "' has type '").concat(typeof config[key], "' expected type is 'boolean'")));
          return;
        }
        cookieValue[key] = config[key];
      }
      cookieValue.version = cookieVersion;
      $.ajax({
        type: 'GET',
        cache: false,
        url: "/ss-cookie?name=".concat(encodeURIComponent(cookieName), "&value=").concat(encodeURIComponent(JSON.stringify(cookieValue))),
        success: resolve,
        error: reject
      });
    })
  };
};
svs.core.cookie_consent.dataHandler = new svs.core.cookie_consent.DataHandler();
 })(window);